import { components, paths } from 'src/generated/v1';
import { useQueryClient } from '@tanstack/react-query';
import { $api } from './api';

export type CarrierCompany = components['schemas']['CarrierCompany'];

export type CarrierItem = CarrierCompany;
type GetCarriersParams = paths['/carrier']['get']['parameters']['query'];

export const useCarrierUpdate = () => {
  const queryClient = useQueryClient();
  const updateMutation = $api.useMutation('put', '/carrier/{carrier_company_id}/activate/{set_active}', {
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['get', '/carrier'] });
    },
  });

  return updateMutation;
};

export const useCarrierQuery = (params: GetCarriersParams) => {
  const query = $api.useQuery('get', '/carrier', {
    params: {
      query: params,
    },
  });
  return query;
};

export const useCarriersQuery = () => {
  return $api.useQuery('get', '/carriers', {});
};

export const useCarrierTermsQuery = () => {
  return $api.useQuery('get', '/carrier/terms', {});
};
